export default __webpack_public_path__ + "static/media/Node.js_logo.dd47e26e.svg";